import React, { useEffect } from "react";
import { Grid, TextField, CardActions, Card, CardContent, Button, Typography, Stack } from "@mui/material";
import { MWhatsNewsService } from "../../services/MWhatsNewsService";
import { useNavigate, useParams } from "react-router-dom";
import { globalService } from "../../services/GlobalService";
import useForm from "../../utility/hooks/UseForm";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MWhatsNewsModel } from "../../models/MWhatsNewsModel";
import Controls from "../../utility/controls/Controls";
import { ROLES } from "../../utility/Config";
import { AuthContext } from "../../utility/context/AuthContext";
import ReactQuill from "react-quill";

const MWhatsNewsForm = (...props: any) => {
  const { auth } = React.useContext(AuthContext);
  globalService.pageTitle = "MWhatsNewss";
  const { whatsNewId } = useParams();
  let navigate = useNavigate();
  const mode = whatsNewId ? "Edit" : "Create";
  const validate = (fieldValues: MWhatsNewsModel = values) => {
    let temp: any = { ...errors };

    if ("WhatsNewTitle" in fieldValues)
      temp.WhatsNewTitle = fieldValues.WhatsNewTitle ? "" : "Whats New Title is required.";

    if ("WhatsNew" in fieldValues)
      temp.WhatsNew = fieldValues.WhatsNew ? "" : "Whats 'New is required.";

    setErrors({ ...temp });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  } = useForm(
    MWhatsNewsService.initialFieldValues,
    validate,
    props?.setCurrentId
  );

  // useEffect(() => {
  //   getMWhatsNews(whatsNewId);
  // }, []);
  const newUser = () => {
    setValues(setFormValue(MWhatsNewsService.initialFieldValues));
  };
  //This is used since in get the null property is not returned
  function setFormValue(model: MWhatsNewsModel) {
    let newModel = {
      WhatsNewId: model.WhatsNewId,
      WhatsNewTitle: model.WhatsNewTitle,
      Active: model.Active,
      WhatsNew: model.WhatsNew,
    }
    return newModel;
  }

  useEffect(() => {
    if (whatsNewId) {
      getMWhatsNews(whatsNewId);
      setErrors({});
    } else newUser();
  }, [whatsNewId]);


  const getMWhatsNews = (whatsNewId: any) => {
    MWhatsNewsService.getById(whatsNewId).then((response) => {
      if (response) {
        let result = response.data;
        setValues(setFormValue(result.data));
      }
    })
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {

      if (whatsNewId) {
        MWhatsNewsService.put(values).then((response: any) => {
          let result = response.data;
          if (response) {
            globalService.success(result.message);
            navigate("/mWhatsNews");
          } else {
            globalService.error(result.message);
          }
        });
      } else {
        MWhatsNewsService.post(values).then((response: any) => {
          if (response) {
            let result = response.data;
            if (result.isSuccess) {
              globalService.success(result.message);
              resetForm();
              navigate("/mWhatsNews");
            } else {
              globalService.error(result.message);
            }
          }
        });
      }
    }
  };

  return (
    <>
      <Typography variant="h5" align="center" sx={{ mb: 2 }}>
        What's New
      </Typography>

      <form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Card sx={{ minHeight: 400, display: "flex", flexDirection: "column" }}>
          <CardContent>
            {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
            <Grid container spacing={2}>

              {/* Title */}
              <Grid item xs={12} sm={8}>
                <Controls.Input
                  label="Title"
                  name="WhatsNewTitle"
                  value={values.WhatsNewTitle}
                  onChange={handleInputChange}
                  error={errors.WhatsNewTitle}
                />
              </Grid>
              {/* Quill Editor Onchange should be done without handleInputChange. bcoz it removes other prop values*/}
              <Grid item xs={12} sm={8}>
                <ReactQuill
                  theme="snow"
                  value={values.WhatsNew || ""}
                  onChange={(content: any) =>
                    setValues((prev: any) => ({ ...prev, WhatsNew: content }))
                  }
                />

                {errors.WhatsNew && (
                  <Typography color="error" variant="caption">
                    {errors.WhatsNew}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} sm={8} className={mode === "Create" ? "hidden" : ""}>
                <Controls.Checkbox
                  name="Active"
                  label="Active"
                  value={values.Active}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <CardActions sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Stack spacing={2} direction="row">
            <Button type="submit" variant="contained">
              Submit
            </Button>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              href="/mWhatsNews"
            >
              Back To List
            </Button>
          </Stack>
        </CardActions>
      </form>
    </>
  );
};

export default MWhatsNewsForm;